var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { accountEntityName } from './backend/features/accounts/shared';
import { groupAccountMapEntityName, groupEntityName, } from './backend/features/groups/shared';
import { userConsentEntityName } from './backend/features/notify-user-consent/shared';
import { organizationEntityName } from './backend/features/organizations/shared';
import { toKebabCase } from './utils';
import { StorageClient } from '@juvare/platform-sdk-js/StorageClient';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
import React from 'react';
export function useAccountStorage() {
    return useStorageClient(accountEntityName);
}
export function useOrganizationStorage() {
    return useStorageClient(organizationEntityName);
}
export class GroupStorageClient extends StorageClient {
    constructor(baseUrl, tokenProvider) {
        super(groupEntityName, baseUrl, tokenProvider);
        this.groupAccountMapStorage = new StorageClient(groupAccountMapEntityName, baseUrl, tokenProvider);
    }
    addAccountsToGroup(groupId, accountIds) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.removeAccountsFromGroup(groupId, accountIds);
            yield this.groupAccountMapStorage.massCreate({
                items: accountIds.map((accountId) => ({ data: { groupId: groupId, accountId: accountId } })),
                auditTags: [toKebabCase(groupAccountMapEntityName).replace(/-+/g, '-')],
            });
        });
    }
    removeAccountsFromGroup(groupId, accountIds) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.groupAccountMapStorage.massDelete({
                filter: [
                    {
                        column: 'groupId',
                        op: '=',
                        value: groupId,
                    },
                    {
                        column: 'accountId',
                        op: 'in',
                        value: accountIds,
                    },
                ],
                auditTags: [toKebabCase(groupAccountMapEntityName).replace(/-+/g, '-')],
            });
        });
    }
}
export function useGroupStorage() {
    return React.useMemo(() => new GroupStorageClient(), []);
}
export function useGroupAccountMapStorage() {
    return useStorageClient(groupAccountMapEntityName);
}
export function useNotifyUserConsentStorage() {
    return useStorageClient(userConsentEntityName);
}
